import { exec } from '../utils/exec';
import type {
  GetVariantSkuDetailsArgs,
  GetVariantSkuDetailsExecVariables,
  GetVariantSkuDetailsExecResponse,
  VariantDetails,
} from '@src/types/catalog';

/**
 * Fetches detailed information for a specific variant SKU
 * @param args - Contains token, partnerCode, and sku
 * @returns Promise resolving to variant details
 */
export const getVariantSkuDetails = async (
  args: GetVariantSkuDetailsArgs
): Promise<VariantDetails> => {
  const { token, partnerCode, sku } = args;

  const query = `
    query variantSkuDetails(
      $sku: String!
      $partnerCode: String!
      $token: String!
    ) {
      restUser(token: $token) {
        partner(code: $partnerCode) {
          variantSkuDetails(sku: $sku) {
            upc
            mpn
            gtin
            partnerSku
            partnerParentSku
            family
            data
            partnerImageUrls
          }
        }
      }
    }
  `;

  const variables: GetVariantSkuDetailsExecVariables = {
    token,
    partnerCode,
    sku,
  };

  const data = await exec<GetVariantSkuDetailsExecVariables, GetVariantSkuDetailsExecResponse>(
    query,
    { variables }
  );

  return data.restUser.partner.variantSkuDetails;
};
